import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Box, Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import { Button } from '../../../../common/button';
import SelectField from '../../../../common/select_field';
import { getEmployerBillingScheduleTypeOptions } from '../../../../common/utils/employer_utils';
import { updateEmployerBillingScheduleNotificationData } from '../../../../../core/utils/notification_utils';
import useNotification from '../../../../../core/hooks/use_notification';
import { updateEmployerBillingScheduleAction, updateEmployerBillingScheduleState } from '../../../../../features/benefit/update_employer_billing_schedule';
import { ApiRequestStatusEnum } from "../../../../../core/enums/common/api";

const UpdateEmployerBillingScheduleDialog = ({ type, refreshEmployer, buttonSx }) => {
    const { showNotification } = useNotification();
    const dispatch = useDispatch();
    const { employerId } = useParams();

    const updateEmployerBillingSchedule = useSelector(updateEmployerBillingScheduleState);

    const [open, setOpen] = useState(false);
    const [newType, setNewType] = useState(type);

    const onClose = () => setOpen(false);

    const onUpdate = () => {
        dispatch(updateEmployerBillingScheduleAction({ employerId: employerId, type: newType }))
            .then(response => {
                showNotification(updateEmployerBillingScheduleNotificationData(response));

                if (response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED) {
                    refreshEmployer();
                    onClose();
                }
            })
    };

    return (
        <Box>
            <Button
                isLoading={ updateEmployerBillingSchedule?.loading }
                onClick={ () => setOpen(true) }
                sx={ buttonSx }
            >
                Zmień
            </Button>
            <Dialog open={ open } onClose={ onClose } fullWidth maxWidth={ 'xs' }>
                <DialogTitle>Aktualizuj harmonogram rozliczania pracodawcy</DialogTitle>
                <DialogContent sx={ { paddingTop: '6px !important' } }>
                    <Grid>
                        <SelectField
                            label="Status"
                            value={ newType }
                            onChange={ event => setNewType(event.target.value) }
                            options={ getEmployerBillingScheduleTypeOptions }
                        />
                    </Grid>
                    <Grid container mt={ 2 } justifyContent="flex-end">
                        <DialogActions sx={ { gap: 2 } }>
                            <Button isLoading={ updateEmployerBillingSchedule?.loading }
                                    onClick={ () => {
                                        onClose();
                                    } }>
                                Anuluj
                            </Button>
                            <Button isLoading={ updateEmployerBillingSchedule?.loading }
                                    onClick={ () => {
                                        onUpdate();
                                    } }>
                                Aktualizuj
                            </Button>
                        </DialogActions>
                    </Grid>
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default UpdateEmployerBillingScheduleDialog;
